import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type ExternalAccessAnalyzerConfig = typeof ExternalAccessAnalyzerConfig._.Config;

export const ExternalAccessAnalyzerConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.ExternalAccessAnalyzer,
  configSchema: z.object({}),
});
